import React from 'react'
import styled from 'styled-components'
import {RequiredAsterisk} from './RequiredAsterisk'

const StyledLabel = styled.label`
  display: block;
  color: var(--label-gray);
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 8px;
`

interface FormLabelProps {
  children: React.ReactNode
  required?: boolean
  htmlFor?: string
}

export const FormLabel: React.FC<FormLabelProps> = ({children, required, htmlFor}) => {
  return (
    <StyledLabel htmlFor={htmlFor}>
      {children}
      {required && <RequiredAsterisk />}
    </StyledLabel>
  )
}

export default FormLabel
